import React from "react";
import { Container } from "react-grid-system";
import Fade from "react-reveal/Fade";
import SectionTitle from "../../components/common/SectionTitle";

const processSteps = [
  { title: "Understand", description: "Review the existing app" },
  { title: "Plan", description: "Define a clear strategy" },
  { title: "Execute", description: "Develop with care" },
  { title: "Deliver", description: "Launch with confidence" },
];

const Process = () => {
  return (
    <section className="section-process-modern">
      <Container>
        <SectionTitle label="My Process" title="Workflow for Success" align="center" />

        <div className="process-timeline">
          {processSteps.map((step, index) => (
            <Fade bottom delay={index * 120} key={index}>
              <div className="process-step">
                <div className="step-node">
                  <span>{index + 1}</span>
                </div>

                <div className="step-card">
                  <h4>{step.title}</h4>
                  <p>{step.description}</p>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Process;
